namespace Areas.Analysis.I181 {
    "use strict";


    $(() => { setWarningText(); });

    export function setWarningText() {
        const warningId = "HasFMLAChecked";

        if (Areas.elementIdExists(warningId)) {
            $.get("/Analysis/I181/GetHasFMLAChecked").then((data) => {
                if (Areas.isNotEmpty(data)) {
                    if (data.hasFMLAChecked === true) {
                        $(`#${warningId}`).text("Data has at least one record with FMLA checked.");
                    }
                    else {
                        $(`#${warningId}`).text("");
                    }
                }
           });
        }
    }

    export function load() {
        const result: any = $("#I181Form").dxForm("instance").validate();

        if (result.isValid) {
            Areas.refreshGrid("I181Grid");
        }
    }

    export function refresh() {
        const data: any = $('#I181Form').dxForm('instance').option('formData');
        const result: any = $("#I181Form").dxForm("instance").validate();

        if (result.isValid) {
            const url = '/Analysis/I181/SqlI181GetData?startDate=' +
                FormatDateForUpload(data.startDate) +  '&endDate=' +
                FormatDateForUpload(data.endDate) +  '&exempt=' +
                data.exempt;

            sendRequest(url, "", "POST", () => { Areas.refreshGrid("I181Grid"); setWarningText(); });
        }
    }

    export function exportData() {
        const data: any = $('#I181Form').dxForm('instance').option('formData');
        const result: any = $("#I181Form").dxForm("instance").validate();

        if (result.isValid) {
            window.location.href = '/Analysis/I181/Export?startDate=' + FormatDateForUpload(data.startDate) +
                '&endDate=' + FormatDateForUpload(data.endDate) + '&exempt=' + data.exempt;
        }
    }

    export function viewFromCellI181List(cellElement, cellInfo) {
        const employeeId = String(cellInfo.data.employeeId);
        const startDate = String(cellInfo.data.payPeriodEndDate);
        const linkInfo = `<a href= '/Employee/Time/Index/${employeeId}?start=${startDate}' target=_blank >View</a>`;
        cellElement.html(linkInfo);
    }

}
